var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95325 10.6661C6.95325 8.43857 8.75901 6.63281 10.9865 6.63281H39.2195C41.447 6.63281 43.2527 8.43857 43.2527 10.6661V38.899C43.2527 41.1266 41.447 42.9323 39.2195 42.9323H10.9865C8.75901 42.9323 6.95325 41.1266 6.95325 38.899V10.6661ZM39.2195 10.6661H10.9865V38.899H39.2195V10.6661Z",
    fill: "#D0D3D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7934 21.1912C18.5299 20.602 19.5764 20.602 20.3129 21.1912L28.9867 28.1302L31.7436 25.3732C32.5312 24.5857 33.8081 24.5857 34.5956 25.3732L42.6622 33.4398C43.4497 34.2273 43.4497 35.5042 42.6622 36.2917C41.8746 37.0793 40.5977 37.0793 39.8102 36.2917L33.1696 29.6512L30.5623 32.2585C29.8357 32.9851 28.679 33.0491 27.8766 32.4072L19.0532 25.3485L10.2297 32.4072C9.36004 33.103 8.09099 32.962 7.39523 32.0923C6.69947 31.2226 6.84048 29.9535 7.71018 29.2577L17.7934 21.1912Z",
    fill: "#D0D3D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2888 17.0087C31.2888 15.8949 32.1917 14.9921 33.3054 14.9921H33.3296C34.4434 14.9921 35.3463 15.8949 35.3463 17.0087C35.3463 18.1225 34.4434 19.0253 33.3296 19.0253H33.3054C32.1917 19.0253 31.2888 18.1225 31.2888 17.0087Z",
    fill: "#D0D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholder);
export default __webpack_public_path__ + "static/media/img-placeholder.5094fee4a78636ad73620f0444a9298f.svg";
export { ForwardRef as ReactComponent };